import { useState } from "react";

export const TestimonialCard = ({
  data
}: {
  data: {
    name: string;
    title: string;
    avatar: string;
    content: string;
  };
}) => {
  const trimLength = 150;

  const [isTrimmed, setTrimmed] = useState(data.content.length > trimLength);
  return (
    <div className="" style={{ maxWidth: 600 }}>
      <div className="flex flex-row h-full p-3 border bg-white rounded-lg text-testimonial border-gray-200 mb-2">
        <div className="flex items-start pt-2">
          <img
            className="h-8 w-8 rounded-full object-cover"
            src={data.avatar}
            alt="User Avatar"
          />
        </div>
        <div className="testimonial-content relative pl-3">
          {/* <div className="absolute top-0 left-0 ml-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="text-primary-200 fill-current w-4 h-4"
              viewBox="0 0 24 24"
            >
              <path d="M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35.208-.086.39-.16.539-.222.302-.125.474-.197.474-.197L9.758 4.03c0 0-.218.052-.597.144C8.97 4.222 8.737 4.278 8.472 4.345c-.271.05-.56.187-.882.312C7.272 4.799 6.904 4.895 6.562 5.123c-.344.218-.741.4-1.091.692C5.132 6.116 4.723 6.377 4.421 6.76c-.33.358-.656.734-.909 1.162C3.219 8.33 3.02 8.778 2.81 9.221c-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539.017.109.025.168.025.168l.026-.006C2.535 17.474 4.338 19 6.5 19c2.485 0 4.5-2.015 4.5-4.5S8.985 10 6.5 10zM17.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35.208-.086.39-.16.539-.222.302-.125.474-.197.474-.197L20.758 4.03c0 0-.218.052-.597.144-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162C14.219 8.33 14.02 8.778 13.81 9.221c-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539.017.109.025.168.025.168l.026-.006C13.535 17.474 15.338 19 17.5 19c2.485 0 4.5-2.015 4.5-4.5S19.985 10 17.5 10z" />
            </svg>
          </div> */}

          {isTrimmed ? (
            <div
              className="text-gray-700 leading-loose whitespace-pre-wra"
              style={{ maxWidth: 400 }}
            >
              {data.content.slice(0, trimLength)}...
              <br />
              <a
                className="text-primary-600 cursor-pointer"
                onClick={() => setTrimmed(false)}
              >
                Read More
              </a>
            </div>
          ) : (
            <div
              className="text-gray-700 leading-loose whitespace-pre-wrap"
              style={{ maxWidth: 400 }}
            >
              {data.content}
            </div>
          )}
          <div className="pl-4 flex flex-row justify-end items-center">
            <p className="font-bold text-gray-800">{data.name}</p>
            <p className="text-gray-600 ml-2">{data.title}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
